<mat-card class="regla-card">
  <app-card-header
    [title]="edit ? 'Editar regla de evento' : 'Nueva regla de evento'"
    subtitle="Generá un aviso automático para tus vehículos"
    icono="rule"
    [botonCerrar]="true"
    (cerrar)="volver()"
  ></app-card-header>

  @if (form) {
    <form [formGroup]="form" autocomplete="off" (ngSubmit)="onSubmit()">
      <mat-card-content class="card-content-crear">
        @if (!puedeCrear) {
          <app-info-banner
            icon="lock"
            title="Sin permiso"
            [message]="
              edit
                ? 'Tu usuario no tiene el permiso para editar eventos personalizados, así que no vas a poder guardar los cambios.'
                : 'Tu usuario no tiene el permiso para crear eventos personalizados, así que no vas a poder guardar esta regla.'
            "
            color="red"
            margin="0 0 12px 0"
          ></app-info-banner>
        }
        <mat-stepper
          #stepper
          [linear]="false"
          [selectedIndex]="edit ? 2 : 0"
          class="regla-stepper"
        >
          <!-- ============ PASO 1: ALCANCE ============ -->
          <mat-step [completed]="paso1Valido">
            <ng-template matStepLabel>¿A quién aplica?</ng-template>

            <div class="paso">
              <app-section-title
                icon="my_location"
                title="Alcance de la regla"
                color="blue"
              ></app-section-title>

              <irx-segmentado
                formControlName="alcance"
                bloque
                class="alcance-toggle"
                [class.bloqueado]="alcanceBloqueado"
              >
                <irx-segmento value="Entidad">
                  <mat-icon>directions_car</mat-icon>
                  Un vehículo
                </irx-segmento>
                <irx-segmento value="Grupo">
                  <mat-icon>workspaces</mat-icon>
                  Un grupo / flota
                </irx-segmento>
                <irx-segmento value="Global">
                  <mat-icon>public</mat-icon>
                  Todos
                </irx-segmento>
              </irx-segmentado>

              <!-- Vehículo -->
              @if (alcance === 'Entidad') {
                @if (vehiculoFijado) {
                  <div class="entidad-fijada">
                    <mat-icon>directions_car</mat-icon>
                    <span>{{ vehiculoFijado.identificacion }}</span>
                  </div>
                } @else {
                  <ng-select
                    [items]="vehiculos$ | async"
                    [minTermLength]="3"
                    bindLabel="identificacion"
                    bindValue="_id"
                    formControlName="idEntidad"
                    placeholder="Buscá el vehículo (mín. 3 letras)"
                    [loading]="loadingVehiculos"
                    [typeahead]="searchTermVehiculos$"
                    (search)="buscarVehiculos($event.term)"
                    notFoundText="Sin resultados"
                    typeToSearchText="Escribí para buscar..."
                    [appendTo]="'body'"
                    class="campo"
                  ></ng-select>
                }
              }

              <!-- Grupo -->
              @if (alcance === 'Grupo') {
                <ng-select
                  [items]="grupos"
                  bindLabel="nombre"
                  bindValue="_id"
                  formControlName="idGrupo"
                  placeholder="Seleccioná el grupo / flota"
                  notFoundText="Sin grupos"
                  [appendTo]="'body'"
                  class="campo"
                ></ng-select>
              }

              @if (alcance === 'Global') {
                <app-info-banner
                  icon="info"
                  title="Aplica a todos los vehículos"
                  message="La regla se evaluará para todos los vehículos del cliente."
                  color="blue"
                  margin="12px 0 0 0"
                ></app-info-banner>
              }
            </div>

            <div class="paso-acciones">
              <button
                irxBoton="principal"
                type="button"
                matStepperNext
                [disabled]="!paso1Valido"
              >
                Siguiente
                <mat-icon>arrow_forward</mat-icon>
              </button>
            </div>
          </mat-step>

          <!-- ============ PASO 2: TIPO DE REGLA ============ -->
          <mat-step [completed]="paso2Valido">
            <ng-template matStepLabel>¿Qué querés detectar?</ng-template>

            <div class="paso">
              <app-section-title
                icon="rule"
                title="Tipo de regla"
                color="blue"
              ></app-section-title>

              <div class="reglas-grid">
                @for (op of opcionesRegla; track op.tipo) {
                  <button
                    type="button"
                    class="irx-opcion regla-opcion"
                    [attr.aria-pressed]="tipoRegla === op.tipo"
                    (click)="seleccionarRegla(op.tipo)"
                  >
                    <mat-icon>{{ op.icon }}</mat-icon>
                    <span class="regla-titulo">{{ op.titulo }}</span>
                    <span class="regla-desc">{{ op.descripcion }}</span>
                  </button>
                }
              </div>
            </div>

            <div class="paso-acciones">
              <button irxBoton="secundario" type="button" matStepperPrevious>
                <mat-icon>arrow_back</mat-icon>
                Atrás
              </button>
              <button
                irxBoton="principal"
                type="button"
                matStepperNext
                [disabled]="!paso2Valido"
              >
                Siguiente
                <mat-icon>arrow_forward</mat-icon>
              </button>
            </div>
          </mat-step>

          <!-- ============ PASO 3: PARÁMETROS ============ -->
          <mat-step [completed]="paso3Valido">
            <ng-template matStepLabel>Configuración</ng-template>

            <div class="paso">
              <app-section-title
                icon="tune"
                title="Parámetros de la regla"
                color="blue"
              ></app-section-title>

              <!-- Velocidad -->
              @if (tipoRegla === 'Velocidad') {
                <div [formGroup]="velocidadForm" class="sub-form">
                  <mat-form-field class="campo">
                    <mat-label>Avisar si supera</mat-label>
                    <input
                      matInput
                      type="number"
                      formControlName="superior a"
                    />
                    <span matSuffix style="padding-right: 10px">km/h</span>
                    <mat-icon matPrefix>speed</mat-icon>
                  </mat-form-field>
                  <mat-form-field class="campo">
                    <mat-label>Tiempo mínimo a esa velocidad</mat-label>
                    <input
                      matInput
                      type="number"
                      min="0"
                      formControlName="tiempoMinimo"
                    />
                    <span matSuffix style="padding-right: 10px">seg</span>
                    <mat-icon matPrefix>timer</mat-icon>
                    <mat-hint>
                      La velocidad debe sostenerse este tiempo seguido para
                      generar el evento (vacío = inmediato)
                    </mat-hint>
                  </mat-form-field>
                </div>
              }

              <!-- Exceso de velocidad por calle -->
              @if (tipoRegla === 'Exceso de velocidad por calle') {
                <div [formGroup]="excesoCalleForm" class="sub-form">
                  <app-info-banner
                    icon="add_road"
                    title="Límite según la calle"
                    message="El límite de velocidad de la calle lo resuelve el sistema en base a la información disponible. El evento salta cuando se supera ese límite."
                    color="blue"
                    margin="0 0 12px 0"
                  ></app-info-banner>
                  <mat-form-field class="campo">
                    <mat-label>Tolerancia</mat-label>
                    <input
                      matInput
                      type="number"
                      step="1"
                      min="0"
                      formControlName="tolerancia"
                      placeholder="10"
                    />
                    <mat-icon matPrefix>percent</mat-icon>
                    <span matSuffix style="padding-right: 10px">%</span>
                    <mat-hint>
                      Ej.: 10 = permite hasta +10% sobre el límite de la calle
                      antes de generar el evento (60 km/h → salta a 66 km/h)
                    </mat-hint>
                  </mat-form-field>
                  <mat-form-field class="campo">
                    <mat-label>Límite de respaldo</mat-label>
                    <input
                      matInput
                      type="number"
                      min="0"
                      formControlName="umbralFallback"
                    />
                    <mat-icon matPrefix>speed</mat-icon>
                    <span matSuffix style="padding-right: 10px">km/h</span>
                    <mat-hint>
                      En calles sin dato de límite se compara contra esta
                      velocidad fija. Vacío = no genera evento en esas calles.
                    </mat-hint>
                  </mat-form-field>
                  <mat-form-field class="campo">
                    <mat-label>Tiempo mínimo a esa velocidad</mat-label>
                    <input
                      matInput
                      type="number"
                      min="0"
                      formControlName="tiempoMinimo"
                    />
                    <span matSuffix style="padding-right: 10px">seg</span>
                    <mat-icon matPrefix>timer</mat-icon>
                    <mat-hint>
                      El exceso debe sostenerse este tiempo seguido para generar
                      el evento (vacío = inmediato)
                    </mat-hint>
                  </mat-form-field>
                </div>
              }

              <!-- Ubicación / geocerca -->
              @if (tipoRegla === 'Ubicación') {
                <div [formGroup]="ubicacionForm" class="sub-form">
                  <ng-select
                    [items]="ubicaciones"
                    bindLabel="identificacion"
                    bindValue="_id"
                    formControlName="idUbicacion"
                    placeholder="Seleccioná la zona / ubicación"
                    notFoundText="Sin ubicaciones"
                    [appendTo]="'body'"
                    class="campo"
                  ></ng-select>
                  <div class="check-row">
                    <mat-checkbox formControlName="dentro">
                      Al entrar
                    </mat-checkbox>
                    <mat-checkbox formControlName="fuera">
                      Al salir
                    </mat-checkbox>
                  </div>
                </div>
              }

              <!-- Detenido -->
              @if (tipoRegla === 'Detenido') {
                <mat-form-field class="campo">
                  <mat-label>Avisar si está detenido más de</mat-label>
                  <input matInput type="number" formControlName="detenido" />
                  <span matSuffix style="padding-right: 10px">min</span>
                  <mat-icon matPrefix>timer</mat-icon>
                </mat-form-field>
              }

              <!-- Recorridos -->
              @if (tipoRegla === 'Recorridos') {
                <div [formGroup]="recorridosForm" class="sub-form">
                  <mat-form-field class="campo">
                    <mat-label>Distancia de tolerancia</mat-label>
                    <input matInput type="number" formControlName="distancia" />
                    <span matSuffix style="padding-right: 10px">m</span>
                    <mat-icon matPrefix>alt_route</mat-icon>
                  </mat-form-field>
                  <div class="check-row">
                    <mat-checkbox formControlName="dentro">
                      Al volver al recorrido
                    </mat-checkbox>
                    <mat-checkbox formControlName="fuera">
                      Al salir del recorrido
                    </mat-checkbox>
                  </div>
                </div>
              }

              <!-- Divergencia GPS -->
              @if (tipoRegla === 'Divergencia GPS') {
                <app-info-banner
                  icon="gps_off"
                  title="Divergencia GPS"
                  message="Se generará un evento cuando el vehículo presente divergencia de GPS sostenida. No requiere parámetros adicionales."
                  color="blue"
                  margin="0 0 12px 0"
                ></app-info-banner>
              }

              <!-- Cuándo genera eventos: sólo las frecuencias que el backend
                   de esta regla respeta (auxiliares/frecuencias-regla.util). -->
              @if (admiteFrecuencia) {
                <mat-divider></mat-divider>

                <app-section-title
                  icon="event_repeat"
                  title="Cuándo genera eventos"
                  color="blue"
                ></app-section-title>

                <div class="sub-form">
                  <ng-select
                    [items]="opcionesFrecuencia"
                    bindLabel="label"
                    bindValue="valor"
                    formControlName="frecuencia"
                    [clearable]="false"
                    [searchable]="false"
                    [appendTo]="'body'"
                    class="campo"
                  ></ng-select>

                  @if (usaPeriodo) {
                    <app-date-picker
                      mode="datetimerange"
                      label="Período"
                      formControlName="periodo"
                    ></app-date-picker>
                  }

                  @if (usaCronograma) {
                    <div [formGroup]="cronogramaForm" class="sub-form">
                      <app-dias-semana-selector
                        formControlName="dias"
                      ></app-dias-semana-selector>

                      <!-- Label siempre arriba: el time-picker escribe el valor en el
                           input nativo y el form-field no lo detecta. -->
                      <div class="horarios-row">
                        <app-time-picker
                          class="horario-field"
                          formControlName="horaInicio"
                          label="Desde"
                          placeholder=""
                          appearance="fill"
                          subscriptSizing="dynamic"
                          floatLabel="always"
                        ></app-time-picker>
                        <app-time-picker
                          class="horario-field"
                          formControlName="horaFin"
                          label="Hasta"
                          placeholder=""
                          appearance="fill"
                          subscriptSizing="dynamic"
                          floatLabel="always"
                        ></app-time-picker>
                      </div>
                    </div>
                  }

                  @if (!cronogramaValido) {
                    <span class="cronograma-error">
                      Elegí al menos un día y un horario con "Desde" distinto de
                      "Hasta".
                    </span>
                  } @else if (!periodoValido) {
                    <span class="cronograma-error">
                      Elegí un período con fecha de inicio anterior a la de fin.
                    </span>
                  } @else {
                    <span class="cronograma-hint">{{ hintFrecuencia }}</span>
                  }
                </div>
              }

              <mat-divider></mat-divider>

              <!-- Comunes -->
              <app-section-title
                icon="notifications_active"
                title="Notificación"
                color="blue"
              ></app-section-title>

              <!-- Tipo de evento: el título con el que aparece el evento -->
              <app-listado-categoria-selector
                [idCliente]="null"
                [categoria]="categoriaTipoEvento"
                [categorias]="[categoriaTipoEvento]"
                placeholder="Tipo de evento (opcional)"
                notFoundText="No hay tipos de evento creados"
                [multiple]="false"
                [showCrearBtn]="true"
                [initialNames]="listadoCategoriaInitialNames"
                (listadoCategoriaChange)="onListadoCategoriaChange($event)"
                class="campo"
              ></app-listado-categoria-selector>

              <ng-select
                [items]="categoriasEvento"
                bindLabel="nombre"
                bindValue="_id"
                formControlName="idCategoriaEvento"
                placeholder="Categoría del evento (opcional)"
                notFoundText="Sin categorías"
                [appendTo]="'body'"
                class="campo"
              ></ng-select>

              <div class="toggles">
                <mat-slide-toggle formControlName="notificar">
                  Notificar a los usuarios
                </mat-slide-toggle>
                <mat-slide-toggle formControlName="atender">
                  Requiere atención
                </mat-slide-toggle>
              </div>

              @if (form.get('notificar')?.value) {
                <ng-select
                  [items]="usuarios"
                  bindValue="_id"
                  formControlName="idsUsuarios"
                  placeholder="Usuarios a notificar (vacío = según ruteo por defecto)"
                  [multiple]="true"
                  [closeOnSelect]="false"
                  [searchFn]="searchUsuario"
                  notFoundText="Sin usuarios"
                  [appendTo]="'body'"
                  class="campo"
                >
                  <ng-template ng-label-tmp let-item="item">
                    <span>{{ item.usuario }}</span>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    <span>{{ item.usuario }}</span>
                    @if (item.datosPersonales?.telefono) {
                      <span class="usuario-tel">
                        ({{ item.datosPersonales.telefono }})
                      </span>
                    }
                  </ng-template>
                </ng-select>
              }
            </div>

            <div class="paso-acciones">
              <button irxBoton="secundario" type="button" matStepperPrevious>
                <mat-icon>arrow_back</mat-icon>
                Atrás
              </button>
              <button
                irxBoton="principal"
                type="submit"
                [disabled]="!formValido || !puedeCrear || loading"
              >
                <mat-icon>check</mat-icon>
                {{ edit ? 'Guardar cambios' : 'Crear regla' }}
              </button>
            </div>
          </mat-step>
        </mat-stepper>
      </mat-card-content>

      <!-- El paso a paso lleva sus propios botones (Siguiente / Crear regla) -->
      <mat-card-actions class="actions-create">
        <button irxBoton="secundario" type="button" (click)="volver()">
          Cancelar
        </button>
      </mat-card-actions>
    </form>
  }
</mat-card>
